// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bv1n","rootMobile":"styles_rootMobile__2T4dT"};